import i18next from "i18next";

export const THEMES = {
    "MUC_OP": {
        "--page-background": "#CBD6D2",
        "--form-background": "#CBD6D2",
        "--form-margin": "24px",
        "--login-form-padding": "24px",
        "--login-form-margin-top": "-24px",
        "--address-form-padding": "24px",
        "--citytax-row-padding": "24px",
        "--citytax-panel-padding": "24px",
        "--citytax-panel-padding-bottom": "24px",
        "--citytax-bodytext-padding-left": "0px",
        "--citytax-travel-reason-text-margin-left": "-32px",
        "--citytax-header-title-white-space": "pre-wrap",
        "--citytax-bodytext-arrow-display": "none",
        "--citytax-button-margin-top": "36px",
        "--signature-form-padding": "24px",
        "--lostcard-form-padding": "24px",
        "--lostcard-form-padding-top": "0px",
        "--lostcard-form-margin-top-offset": "-24px",
        "--checkout-bodytext-margin-top": "48px",
        "--checkout-img-width": "296px",
        "--checkout-img-height": "444px",
        "--checkout-img-margin-top": "-48px",
        "--corona-page-padding": "24px",
        "--checkin-card-margin-top": "0px",
        "--checkout-card-margin-top": "0px",
        "--keycard-card-margin-top": "0px",
        "--flipkachel-justify-content": "flex-start",
        "--checkin-card-margin-left": "0px",
        "--signature-form-margin-left": "0px",
        "--signature-form-padding-left": "0px",
        "--address-form-margin-left": "0px",
        "--address-form-padding-left": "0px",
        "--font-family-header": "'Almarai'",
        "--font-family-body": "'Almarai'",
        "--font-weight-header": "700",
        "--flipkachel-title-font-size": "1.5rem",
        "--flipkachel-image-fit": "contain",
        "--header-title-font-size": "38px",
        "--header-title-line-height": "1.1",
        "--login-container-max-width": "1400px",
        "--login-container-padding-left": "112px",
        "--login-container-padding-right": "112px",
        "--login-row-flex-wrap": "nowrap",
        "--login-row-column-gap": "42px",
        "--bodytext-width": "100%",
        "--bodytext-span-display": "block",
        "--bodytext-span-width": "100%"
    },
};

export function getLocationId() {
    return localStorage.getItem("hotelId") || localStorage.getItem("verificationCode") || "";
}

export function applyLocationTheme() {
    const vars = THEMES[getLocationId()] || {};
    for (const [key, value] of Object.entries(vars)) {
        document.documentElement.style.setProperty(key, value);
    }
}

export function getLocationTranslationKey(baseKey) {
    const id = getLocationId();
    const [section, ...rest] = baseKey.split(".");
    const overrideKey = id ? `${section}.${id}.${rest.join(".")}` : "";
    if (overrideKey && i18next.exists(overrideKey)) {
        return overrideKey;
    }
    return baseKey;
}
